import { render, staticRenderFns } from "./BillingItem.vue?vue&type=template&id=226b68ff&"
import script from "./BillingItem.vue?vue&type=script&lang=ts&"
export * from "./BillingItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports